import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Sun, Waves, Droplet, Hand, Shirt } from "lucide-react";

const ICONS = [Sun, Waves, Droplet, Hand, Shirt];

export const Aftercare = ({ t }) => {
  return (
    <section
      id="aftercare"
      className="relative py-14 md:py-20 bg-bendito-bg"
      data-testid="aftercare-section"
    >
      <div className="max-w-5xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="mb-12 max-w-2xl reveal">
          <div className="eyebrow mb-3">{t.aftercare.eyebrow}</div>
          <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
            <span className="ink-underline">{t.aftercare.title}</span>
          </h2>
          <p className="text-bendito-muted mt-3">{t.aftercare.sub}</p>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="aftercare-accordion">
          {t.aftercare.items.map((item, i) => {
            const Icon = ICONS[i] || Sun;
            return (
              <AccordionItem
                key={i}
                value={`af-${i}`}
                className="bg-bendito-surface border border-bendito-border hover:border-bendito-orange transition-colors data-[state=open]:border-bendito-orange rounded-none"
                data-testid={`aftercare-item-${i}`}
              >
                <AccordionTrigger className="px-5 py-5 hover:no-underline">
                  <div className="flex items-center gap-4 text-left">
                    <Icon className="w-5 h-5 text-bendito-orange shrink-0" strokeWidth={1.5} />
                    <span className="font-heading text-bendito-ink text-xl tracking-wider uppercase">
                      {item.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-5 pb-5 text-bendito-muted leading-relaxed">
                  {item.body}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>

        <p
          className="mt-8 text-bendito-muted text-sm italic font-mono tracking-wide"
          data-testid="aftercare-note"
        >
          {t.aftercare.note}
        </p>
      </div>
    </section>
  );
};

export default Aftercare;
